import { apiService } from '@/services/Api'
import { MktuClassWord } from '@/services/Api/generated'
import { Validator } from '@/services/Validator'
import { MktuClassStore } from '@/store/Mktu/MktuClass'
import { MktuClassPrototype } from '@/store/Mktu/MktuClass/MktuClassPrototype'
import { makeAutoObservable } from 'mobx'
import * as Yup from 'yup'
import { MktuClassesList } from '../MktuClassesList'

export class SearchMktuClassStore {
  selectedWords: MktuClassWord[] = []
  foundClasses: MktuClassStore[] = []
  notFoundWords: string[] = []

  get allClasses() {
    return this.mktuClassesList.classes
  }

  validatorSearchWord = new Validator(
    Yup.object().shape({
      words: Yup.array().min(1, 'Выберите хотя бы один товар или услугу'),
    })
  )

  validate() {
    return this.validatorSearchWord.validateAll({
      words: this.selectedWords,
    })
  }

  setSelectedWords(words: MktuClassWord[]) {
    this.selectedWords = words
    this.validatorSearchWord.validateAll({ words: this.selectedWords })
  }

  resetSelectedWords() {
    this.selectedWords = []
  }

  setFoundClasses(classes: MktuClassStore[]) {
    this.foundClasses = classes
  }

  setNotFoundWords(words: string[]) {
    this.notFoundWords = words
  }

  get selectedFoundClasses() {
    return this.foundClasses
      .map((mktuClass) => {
        return mktuClass.selectedWordsNames.length !== 0 ? mktuClass : null
      })
      .filter((c) => c != null)
  }

  constructor(public mktuClassesList: MktuClassesList) {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  loadingClasses = false
  startLoading() {
    this.loadingClasses = true
  }
  stopLoading() {
    this.loadingClasses = false
  }

  async findClassesByWords() {
    this.startLoading()
    try {
      const response = await apiService.mktu.search({
        searchRequest: { words: this.selectedWords.map((w) => w.word) },
      })

      const promisesGetWords = []
      if (response.status) {
        const classes = Object.entries(response.data.groups)
          .map(([numberMktuClass, words]) => {
            const mktuClass = this.findMktuClassByNumber(
              Number(numberMktuClass)
            )
            if (mktuClass) {
              const cloneMktuClass = this.cloneMktuClass(mktuClass)
              if (cloneMktuClass.words.length === 0) {
                promisesGetWords.push(cloneMktuClass.getWords())
              }
              cloneMktuClass.setSelectedWordsNames(words.map((w) => w.word))
              return cloneMktuClass
            }
            return null
          })
          .filter((c) => c != null)

        await Promise.allSettled(promisesGetWords)
        this.setFoundClasses(classes)
        this.setNotFoundWords(response.data.undefined)
      }
    } finally {
      this.stopLoading()
    }
  }

  findMktuClassByNumber(number: MktuClassStore['number']) {
    return this.allClasses.find((i) => i.number === number)
  }

  cloneMktuClass(mktuClass: MktuClassStore) {
    return new MktuClassPrototype(mktuClass).clone()
  }
}
